exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#iframe_payment{height:920px;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/manage-purchase/my-purchase/my-purchase.styl
// module id = 901
// module chunks = 0